import { z } from 'zod';
import { ObjectIdSchema } from './object-id.schema';
/**
 * One request row's outcome on an initial-setup commit endpoint, aligned by
 * index with the request's create array. Skipped rows (skip-if-exists hit)
 * return the EXISTING entity's id, so the wizard can convert a colliding
 * create into an in-place update instead of silently losing the row's edits.
 */ export const CommittedRowSchema = z.object({
    _id: ObjectIdSchema,
    /** false = an entity with this row's natural key already existed (row skipped). */ created: z.boolean()
});

//# sourceMappingURL=bulk-commit.schema.js.map